import { render } from "./purchase-chart.vue?vue&type=template&id=5dd09aee"
import script from "./purchase-chart.vue?vue&type=script&lang=ts"
export * from "./purchase-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script